import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/packages/components/layouts/LayoutSite/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/packages/theme/styles/global.scss")